// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

/**
 * A fast, lightweight pattern matcher for tree structures such as an Abstract Syntax Tree (AST).
 *
 * @packageDocumentation
 */

export * from './TreePattern';
